import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { promiseMiddleware, localStorageMiddleware, authMiddleware } from './middleware';
import reducer from './reducer';

// router 설정관련
import { routerMiddleware } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory';

// 히스토리 생성(네비게이션 관리를 위한 생성)
export const history = createHistory();

// 라우트 미들웨어 등록
const myRouterMiddleware = routerMiddleware(history); 

const getMiddleware = () => {
  if (process.env.NODE_ENV === 'production') {
    return applyMiddleware(myRouterMiddleware, promiseMiddleware, localStorageMiddleware, authMiddleware);
  } else {
    // 개발환경시 로그 사용(developement)
    return applyMiddleware(myRouterMiddleware, promiseMiddleware, localStorageMiddleware, authMiddleware, createLogger())
  }
};

export const store = createStore(
  reducer, composeWithDevTools(getMiddleware()));


// WEBPACK FOOTER //
// ./src/store.js